export default __webpack_public_path__ + "static/media/raffle_holiday___sneakers_n.62131915.png";